import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { package as packagePropType } from 'lib/CustomPropTypes';

import WaffleList from '../WaffleList';
import WaffleHeader from '../WaffleHeader';

import styles from '../styles.module.scss';

const mapStateToProps = ({ shared }) => ({
  vertical: shared.vertical,
});

@connect(mapStateToProps)
class Waffle extends React.Component {
  height = null;

  static propTypes = {
    content: packagePropType.isRequired,
    vertical: PropTypes.string,
    pkgClassName: PropTypes.string,
    adsDisabled: PropTypes.bool,
  }

  static defaultProps = {
    vertical: 'today',
    pkgClassName: 'pkg waffle',
    adsDisabled: false,
  }

  render() {
    const {
      content = {},
      adsDisabled,
      pkgClassName,
      vertical,
    } = this.props;
    const { metadata = {}, packageIndex, id } = content || {};
    const {
      title,
      description,
      shortDescription,
      attribution,
      backgroundImageUrl,
      logoUrl,
    } = metadata || {};

    const waffleCards = (content.items || []).filter((item) => item);
    return (
      <div
        className={classNames(pkgClassName, styles.waffle)}
        ref={(e) => { this.container = e; }}
        data-packageid={id}
      >
        <WaffleHeader
          backgroundImageUrl={backgroundImageUrl}
          title={title}
          logoUrl={logoUrl}
          description={description}
          shortDescription={shortDescription}
          attribution={attribution}
          cardCount={waffleCards.length}
          animateBackground
          packageIndex={packageIndex}
          content={content}
        />
        <WaffleList
          cards={waffleCards}
          vertical={vertical}
          adsDisabled={adsDisabled}
          metadata={content.metadata}
        />
      </div>
    );
  }
}

export default Waffle;
